


























































































import { defineComponent, ref, watch, watchEffect, computed } from '@vue/composition-api';
import { useApolloModel } from 'vue-apollo-model';
import { DataCenterModuleType } from './type';
import { DataCenterModel } from './model';
import { TAB_NAME } from './const';
import selectbox from '@/components/selectbox/index.vue';
import sumDisplay from './components/sum-display.vue';
import chartModule from './components/chart-module.vue';
import gameTab from './components/game/game-tab.vue';
import gameV2 from './components/game-v2/index.vue';
import selectGame from './components/game-v2/components/select-game.vue';
import { handleWarningMessageToast } from '@/common/util';

export default defineComponent({
    components: {
        selectbox,
        sumDisplay,
        chartModule,
        gameTab,
        gameV2,
        selectGame
    },
    setup(props, context) {
        const model = useApolloModel(DataCenterModel);
        const selectedApp = ref('');
        const selectedTab = ref('');
        const activeMiniGameId = ref('');
        const gameDataloadOver = ref(true);

        const activeMiniGameSection = computed(() => {
            // console.log('activeMiniGameSection', model.miniGameList.find((item: any) => item.appId === activeMiniGameId.value), activeMiniGameId.value)
            return model.miniGameList.find((item: any) => item.appId === activeMiniGameId.value);
        })

        // 更新选中的游戏
        function updateMinigameId(appId: string) {
            if(!gameDataloadOver.value) {
                handleWarningMessageToast('切换游戏太频繁啦，请等一等数据~')
                return;
            };
            gameDataloadOver.value = false;
            activeMiniGameId.value = appId;
        }

        function loadOver() {
            gameDataloadOver.value = true;
        }

        async function postVisitedId() {
            if (model.appId && model.dataTab) {
                await model.reportVisitMutate({
                    appId: model.appId,
                    tabName: model.dataTab,
                });
            }
        }

        function isGameTab() {
            return selectedTab.value === TAB_NAME.GAMETAB;
        }

        async function switchType(item: DataCenterModuleType) {
            model.appId = '';
            await model.chartMutate({ tabName: item.tabName });
            model.appId = model.lastVisitApp;
            model.dataTab = item.tabName;
            selectedTab.value = item.tabName;
            if (!isGameTab()) {
                selectedApp.value = model.lastVisitApp;
            }
        }

        function gotoContorllCenter() {
            context.root.$router.push({
                path: '/platform/controllCenter/mobile',
            });
        }

        watch(
            () => selectedApp.value,
            async (val: string) => {
                model.appId = val;
                await postVisitedId();
            },
            { immediate: true },
        );

        watch(
            () => model.dataCenterModule,
            async () => {
                if (model.dataCenterModule?.length) {
                    model.dataTab = model.dataCenterModule[0].tabName;
                    await switchType(model.dataCenterModule[0]);
                }
            },
        );

        watchEffect(() => {
            if (!model.isLoading && model.dataTabQuery.data?.result !== 1) {
                context.root.$router.push({
                    name: 'noDataAuthority',
                });
            }
        });

        return {
            loadOver,
            gameDataloadOver,
            switchType,
            model,
            isGameTab,
            selectedApp,
            gotoContorllCenter,
            activeMiniGameSection,
            activeMiniGameId,
            updateMinigameId
        };
    },
});
